/* TwoMemo brand JS — lightweight, dependency-free.
   - Scroll reveal via IntersectionObserver
   - Honours prefers-reduced-motion
   Runs once; also re-scans when sections are re-rendered in the theme editor. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var nodes = (root || document).querySelectorAll('.tm-reveal:not(.is-in)');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function init() { reveal(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run when a section is loaded/reordered.
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
